<div>
  <app-input-pincode-modal
    [order]="order"
    [config]="modalConfig"
    *ngIf="modalConfig.showOrderPincode"
    (emitOpenConditions)="openConditions()"
    (emitOrderSucceeded)="openOrderSucceeded()"
    (emitOrderFailed)="openOrderFailed($event)"
    (emitOrderTimeOut)="openOrderMessage()"
    [titleKey]="title"
    [pincodeDescriptionKey]="description"
    [pincodeIncorrectKey]="'eos-tv-shop-ii.text.input-pincode-modal-pincode-incorrect'"
    [infoKey]="'eos-tv-shop-ii.text.input-pincode-modal-info'"
    [watchConditionsButtonText]="'eos-tv-shop-ii.lbl.input-pincode-modal-watch-conditions'"
    [pincodeRemainingTimeKey]="'eos-tv-shop-ii.text.input-pincode-modal-pincode-time-remaining'"
    (emitOnBack)="onBack()"
  ></app-input-pincode-modal>
  <app-conditions-modal
    [config]="modalConfig"
    *ngIf="modalConfig.showOrderConditions"
    (emitCloseConditions)="closeConditions()"
    [titleKey]="'eos-tv-shop-ii.title.conditions-modal'"
    [descriptionKey]="conditionsLabelKey | translate" [closeButtonTextKey]="'eos-tv-shop-ii.btn.conditions-modal-close'"
  ></app-conditions-modal>
  <app-order-completed
    [order]="order"
    [config]="modalConfig"
    *ngIf="modalConfig.showOrderSucceeded"
    (emitCloseOrderSucceeded)="closeModal()"
    [titleKey]="orderSucceededTitleKey"
    [descriptionKey]="orderSucceededDescriptionKey"
    [closeButtonTextKey]="'eos-tv-shop-ii.btn.order-succeeded-close'"
    (emitOnBack)="onBack()"
  ></app-order-completed>
  <app-order-failed
    [config]="modalConfig"
    *ngIf="modalConfig.showOrderFailed"
    (emitCloseOrderFailed)="closeModal()"
    [error]="error"
    (emitOnBack)="onBack()"
  ></app-order-failed>
  <app-order-message
    [order]="order"
    [config]="modalConfig"
    *ngIf="modalConfig.showOrderMessage"
    (emitCloseOrderMessage)="closeModal()"
    (emitOnBack)="onBack()"
  ></app-order-message>
</div>
